/**
 * Auth UI tokens & links — change values here only.
 * Aligned to Figma Login Page (node 1:758).
 */
export const AUTH_COLORS = {
  primary: "#0011D3",
  primaryHover: "#000FB8",
  bgSoft: "#EDF2FE",
  bgSky: "#C8ECFD",
  bgGlow: "#C7DCFE",
  text: "#171A1C",
  textStrong: "#040625",
  textSecondary: "#848F9A",
  border: "#C7CCD1",
  borderSecondary: "#E6E8EA",
  inputBg: "#FDFDFD",
  surface: "#FDFDFD",
  white: "#FFFFFF",
  buttonLabel: "#F9FAFA",
  error: "#D32F2F",
  errorBg: "#FDECEC",
};

export const AUTH_FONT =
  '"Poppins", "TTHoves", "Segoe UI", sans-serif';

export const AUTH_CONTACT = {
  quickHelpLabel: "Quick Help:",
  phoneDisplay: "+91 XXXXX-XXXXX",
  phoneHref: "tel:+91XXXXXXXXXX",
};

function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function formatPhoneDisplay(value) {
  var digits = digitsOnly(value);
  if (digits.length === 12 && digits.indexOf("91") === 0) {
    digits = digits.slice(2);
  }
  if (digits.length === 11 && digits.charAt(0) === "0") {
    digits = digits.slice(1);
  }
  if (digits.length === 10) {
    return (
      "+91 " +
      digits.slice(0, 5) +
      "-" +
      digits.slice(5)
    );
  }
  if (!digits) {
    return "";
  }
  return "+" + digits;
}

export function formatPhoneHref(value) {
  var digits = digitsOnly(value);
  if (digits.length === 10) {
    return "tel:+91" + digits;
  }
  if (digits.length === 12 && digits.indexOf("91") === 0) {
    return "tel:+" + digits;
  }
  if (!digits) {
    return AUTH_CONTACT.phoneHref;
  }
  return "tel:+" + digits;
}

/**
 * Prefer assigned HR phone, then portal default env, then static fallback.
 */
export function resolveQuickHelpContact(user) {
  var raw =
    (user && (user.hrPhoneNumber || user.hrHelpPhone)) ||
    process.env.REACT_APP_HR_HELP_PHONE ||
    "";
  var display = formatPhoneDisplay(raw);
  return {
    phoneDisplay: display || AUTH_CONTACT.phoneDisplay,
    phoneHref: display ? formatPhoneHref(raw) : AUTH_CONTACT.phoneHref,
  };
}

export const AUTH_LINKS = {
  terms: "https://spanidea.com/terms-and-conditions",
  privacy: "https://spanidea.com/privacy-policy",
  cookies: "https://spanidea.com/cookie-policy",
  worklife: "https://spanidea.com/",
  copyright: "©2026. Spanidea. All Rights Reserved.",
  termsLabel: "Terms & Conditions",
  privacyLabel: "Privacy Policy",
  cookiesLabel: "Cookies Policy",
  worklifeLabel: "Spanidea Worklife",
};

export const AUTH_SOCIAL = [
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/spanidea/posts/?feedView=all",
  },
  {
    id: "youtube",
    label: "Youtube",
    href: "https://www.youtube.com/@spanideasystem",
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/spanideainc/",
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/people/Spanidea/61589859433778/",
  },
  {
    id: "x",
    label: "Twitter",
    href: "https://x.com/SpanIdeainc",
  },
];
